import privateAxios from "../utils/axiosPrivate";
import { getIdentificationURL } from "../utils/constants/apiEndPoints";

const useIdentificationApi = () => {
  const getIdentification = async () => {
    const response = await privateAxios.get(getIdentificationURL);
    return response;
  };

  return { getIdentification };
};

export default useIdentificationApi;
